module.exports = __webpack_public_path__ + "static/media/login-with-paypal.903838a6.png";